var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse, _ellipse2, _ellipse3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 200,
    viewBox: "0 0 276 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276 99.9991C276 57.9202 241.888 23.8086 199.81 23.8086H76.1905C34.1116 23.8086 0 57.9202 0 99.9991V123.809C0 165.887 34.1116 199.999 76.1905 199.999H199.81C241.888 199.999 276 165.887 276 123.809V99.9991Z",
    fill: "#FF5043"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1532_6756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 276,
    height: 200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276 76.1905C276 34.1116 241.888 0 199.81 0H76.1905C34.1116 0 0 34.1116 0 76.1905V123.81C0 165.888 34.1116 200 76.1905 200H199.81C241.888 200 276 165.888 276 123.81V76.1905Z",
    fill: "#23BA3B"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1532_6756)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8334 149.931L106.38 135.912C107.761 135.396 109.194 135.031 110.653 134.822L154.07 128.616C157.763 128.088 161.53 128.577 164.966 130.03L222.872 154.523C227.909 156.653 231.887 160.706 233.922 165.782L263.772 240.214C269.269 253.92 258.921 268.77 244.16 268.36L225.071 267.829C223.603 267.788 222.277 266.943 221.621 265.63L221.108 264.603C219.464 261.312 214.535 262.241 214.202 265.906C214.031 267.787 212.453 269.228 210.564 269.228H52.0721C38.4744 269.228 28.6383 256.241 32.3228 243.152L39.6272 217.203L56.4142 163.075C58.2959 157.007 62.8822 152.154 68.8334 149.931Z",
    fill: "#FBF3E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.537 139.999L159.715 127.809L108.459 135.136L93.8633 140.586C112.951 161.998 147.613 179.513 188.537 139.999Z",
    fill: "#AEAEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.316 130.006C115.488 127.662 113.828 118.283 112.852 113.886C104.651 105.679 98.6953 85.5533 96.7427 76.5161L90.8848 50.87L105.53 31.8187L134.819 31.0859C143.85 39.8789 163.23 58.0509 168.502 60.3957C175.092 63.3267 175.092 71.3869 172.896 79.4471C171.138 85.8952 166.305 88.4843 164.109 88.9728L161.18 100.697C161.912 109.001 163.669 126.05 164.841 127.808C166.013 129.567 173.628 133.914 177.289 135.868C143.899 167.523 114.561 149.546 104.065 136.601C106.994 135.38 113.145 132.351 114.316 130.006Z",
    fill: "#E5A072"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.186 100.781C161.923 109.116 163.673 126.057 164.84 127.81C166.012 129.569 173.627 133.916 177.288 135.87C173.45 139.509 169.665 142.492 165.956 144.903C147.186 137.792 125.064 128.039 113.837 118.97C113.66 117.919 113.472 116.904 113.289 115.98C120.672 119.556 131.808 121.715 142.141 119.017C151.199 116.653 157.013 108.526 161.186 100.781Z",
    fill: "#BE693B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.572 69.9219C167.525 71.1431 170.698 74.4649 167.769 77.9821",
    stroke: "#232323",
    strokeWidth: 2.93098,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0098 71.3867C99.4269 87.5071 106.993 119.455 127.496 121.213",
    stroke: "#232323",
    strokeWidth: 2.93098,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.206 72.1204V80.9133C86.4901 60.3965 86.4902 49.8938 87.9547 47.2071L86.4902 45.0088C97.6203 9.83709 129.204 13.2566 143.605 19.3628C164.108 19.949 169.721 47.4513 169.966 61.1292C164.693 58.7844 161.911 65.5257 161.179 69.1894C160.593 62.1551 149.707 48.6726 144.337 42.8106L129.692 37.6814C120.32 51.1639 105.284 53.5575 98.9382 53.069C93.6661 56.5862 96.2534 67.2354 98.206 72.1204Z",
    fill: "#232323"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M119.443 70.6562C119.931 75.7855 120.614 86.6301 119.443 88.9749C117.978 91.9058 123.104 93.3713 127.497 91.9058",
    stroke: "#232323",
    strokeWidth: 2.34478,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.8 62.2497C109.509 57.7627 112.453 60.0248 113.505 61.6345C113.883 62.2128 113.531 62.8833 112.886 63.1319L110.615 64.0077C106.382 65.6398 102.496 68.0575 99.1616 71.1334C98.7287 71.5326 98.0389 71.5218 97.7522 71.0076C96.7701 69.2466 96.9163 66.1841 102.8 62.2497Z",
    fill: "#232323"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.635 54.4006C138.036 54.3335 141.977 56.2862 144.659 58.3047C145.837 59.1911 144.843 60.8876 143.394 60.6186C132.484 58.5933 124.509 60.9836 123.371 60.1207C122.066 59.1309 121.435 54.5399 132.635 54.4006Z",
    fill: "#232323"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1532_6756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 70,
    width: 23,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.781 70.6562C105.59 70.6562 100.351 75.1608 98.6028 77.9834C98.33 78.4239 98.3945 78.9941 98.715 79.4012C109.139 92.6395 129.467 70.6562 115.781 70.6562Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1532_6756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.829,
    cy: 75.4228,
    rx: 6.59067,
    ry: 6.59419,
    transform: "rotate(-19.6555 108.829 75.4228)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.726,
    cy: 77.2519,
    rx: 4.39344,
    ry: 4.39647,
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1532_6756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 64,
    width: 23,
    height: 14
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.873 64.1289C132.682 64.1289 127.443 68.6334 125.695 71.4561C125.422 71.8965 125.486 72.4668 125.807 72.8738C136.231 86.1121 156.559 64.1289 142.873 64.1289Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1532_6756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.92,
    cy: 68.8954,
    rx: 6.59067,
    ry: 6.59419,
    transform: "rotate(-19.6555 135.92 68.8954)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.817,
    cy: 70.7246,
    rx: 4.39344,
    ry: 4.39647,
    fill: "#232323"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.529 47.0897L187.245 34.078",
    stroke: "white",
    strokeWidth: 2.49084,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.138 53.2965L195.863 44.1484",
    stroke: "white",
    strokeWidth: 2.49084,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M187.331 60.1954L202.763 57.3541",
    stroke: "white",
    strokeWidth: 2.49084,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.404 75.0518C102.601 73.342 108.752 70.0691 115.781 70.6553",
    stroke: "#232323",
    strokeWidth: 2.34478,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5762 81.0156C65.0281 99.0011 56.0316 138.376 64.4305 151.992",
    stroke: "#232323",
    strokeWidth: 2.14286,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2344 76C65.0199 83.1787 61.4291 98.8948 64.7814 104.329",
    stroke: "#232323",
    strokeWidth: 2.14286,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M221.781 84C223.996 91.1787 227.587 106.895 224.234 112.329",
    stroke: "#232323",
    strokeWidth: 2.14286,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.496 68.5244C129.693 66.8147 135.844 63.5418 142.873 64.128",
    stroke: "#232323",
    strokeWidth: 2.34478,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 6.65887,
    cy: 2.67575,
    rx: 6.65887,
    ry: 2.67575,
    transform: "matrix(0.978901 -0.204334 0.204064 0.978958 132.621 82.9023)",
    fill: "#E50A3E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 6.65887,
    cy: 2.67575,
    rx: 6.65887,
    ry: 2.67575,
    transform: "matrix(0.978901 -0.204334 0.204064 0.978958 103.332 88.7656)",
    fill: "#E50A3E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.93239,
    cy: 2.4674,
    rx: 7.93239,
    ry: 2.4674,
    transform: "matrix(0.988147 -0.153511 0.153304 0.988179 126.764 101.668)",
    fill: "#232323"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2331 199.145L65.1168 157.152C64.7013 156.285 63.8686 155.692 62.913 155.585L44.3464 153.491C42.6768 153.302 41.22 154.621 41.2414 156.302L41.9785 214.31C42.003 216.236 43.9227 217.558 45.7303 216.895L83.676 202.973C85.2224 202.406 85.9447 200.63 85.2331 199.145Z",
    fill: "#FBF3E7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8426 115.738C28.7018 123.078 28.9475 131.859 30.9629 135.332C27.54 138.967 31.341 143.123 33.6695 144.747C36.0705 151.3 45.5874 167.138 53.2713 165.805C59.4184 164.74 64.5207 160.687 66.3034 158.794L64.0771 150.69C68.5306 140.135 65.0893 127.768 62.8119 122.904C64.5947 121.011 68.086 116.211 67.7892 112.157C67.4183 107.089 62.7687 106.564 43.8426 115.738Z",
    fill: "#E5A072"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1067 113.489C59.3383 111.392 62.799 110.023 64.6254 109.601C65.8187 110.154 67.9914 111.488 67.1356 112.397C66.066 113.533 61.0671 116.11 60.1067 113.489Z",
    fill: "#EFC6AA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9269 118.385L56.5908 114.037",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5449 114.844C60.3163 118.12 46.5841 124.843 37.2062 130.068",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2726 146.08C51.7434 144.063 59.2833 140.851 61.6756 144.136C64.6661 148.243 62.5268 150.515 56.873 153.332",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.567 136.664C48.3612 134.152 56.8223 129.263 60.4545 132.689C64.0868 136.114 63.3793 142.023 62.5716 144.55",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8588 122.097C56.2568 122.585 63.2492 125.719 60.4549 132.692",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4316 158.332C71.3799 176.189 86.9644 213.451 101.716 219.642",
    stroke: "#232323",
    strokeWidth: 2.14286,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M219.518 200.905L227.596 155.044C227.763 154.097 228.406 153.302 229.297 152.941L246.615 145.923C248.172 145.292 249.93 146.17 250.362 147.794L265.256 203.86C265.75 205.721 264.257 207.512 262.338 207.36L222.048 204.173C220.406 204.043 219.232 202.528 219.518 200.905Z",
    fill: "#FBF3E7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M227.103 159.499C224.68 178.1 216.173 218.551 201.522 231.549",
    stroke: "#232323",
    strokeWidth: 2.14286,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 109.429C253.5 112.419 255.626 120.943 254.619 124.831C258.893 127.409 256.351 132.436 254.545 134.627C253.995 141.585 249.09 159.401 241.331 160.188C235.124 160.817 229.12 158.289 226.894 156.946L226.858 148.541C219.73 139.575 219.718 126.738 220.602 121.44C218.376 120.097 213.723 116.415 212.918 112.43C211.912 107.45 216.249 105.692 236.944 109.429Z",
    fill: "#E5A072"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.677 111.645C220.853 109.418 217.152 109.032 215.279 109.118C214.279 109.972 212.545 111.842 213.614 112.487C214.949 113.292 220.457 114.428 220.677 111.645Z",
    fill: "#EFC6AA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M223.129 116.039L224.209 111.223",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M214.84 114.684C221.72 116.161 236.754 118.937 247.191 121.443",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M240.84 139.844C236.955 138.837 228.829 137.774 227.409 141.583C225.633 146.343 228.305 147.955 234.508 149.146",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M240.913 130.047C237.546 128.381 228.083 125.952 225.506 130.229C222.929 134.506 225.2 140.007 226.658 142.223",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M229.972 117.978C226.831 119.364 220.94 124.266 225.506 130.228",
    stroke: "#232323",
    strokeWidth: 2.23356,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404-error.5ae840677e46881192b39a50036f76d2.svg";
export { ForwardRef as ReactComponent };